module.exports = __webpack_public_path__ + "static/media/same_books.c725f17a.png";